import type { ReactNode } from "react";
import type { PartnerMeResponse, PartnerOrgProfileResponse } from "@dearbill/shared";
import { useApi } from "../auth/useApi";
import { usePartnerMe } from "../auth/usePartnerMe";
import { useOrg } from "../shell/OrgContext";
import { OrganizationTab } from "./OrganizationTab";

/**
 * Route adapter for `/orgs/:orgId/organization`: feeds the org-profile fetch
 * and the lift-on-save callback from `OrgContext` into `OrganizationTab`, which
 * keeps a prop-based contract so it stays easy to test in isolation.
 */
export function OrganizationRoute(): ReactNode {
  const { orgId, res, setRes } = useOrg();
  const api = useApi();
  const { setMe } = usePartnerMe();
  function saved(next: PartnerOrgProfileResponse): void {
    setRes(next);
    // The organization list must reflect the server's new readiness after submission.
    void api<PartnerMeResponse>("/api/partner/me")
      .then(setMe)
      .catch(() => {});
  }
  return <OrganizationTab orgId={orgId} res={res} onSaved={saved} />;
}
